export const EMPLOYEES_LIST_REFERRER_KEY = "employees_list_referrer";

export enum EmployeePageSection {
  positions = "positions",
  workInfo = "work-info",
  documents = "documents",
  timeOff = "time-off",
  positionRequests = "position-requests",
  feedbackEvaluation = "feedback-evaluation",
  goals = "goals",
  tasks = "tasks",
  tasksRelated = "tasks-related",
}
